import { defineArticleAssets } from "@th-m/blogs/mdx";

export default defineArticleAssets({
  "neural-inference-figure": { kind: "interactive", label: "Neural Inference Figure", tags: ["article-interactive", "mdx-component"] },
  "central-queue-to-bounded-loops-motif": { kind: "figure", label: "Central Queue to Bounded Loops Motif", tags: ["article-figure", "ai-factory-series", "mdx-component"] },
  "term-of-art-implementation-motif": { kind: "figure", label: "Term of Art to Implementation Motif", tags: ["article-figure", "ai-factory-series", "mdx-component"] },
  "proof-pipeline-figure": { kind: "figure", label: "Proof Pipeline Figure", tags: ["article-figure", "mdx-component"] },
  "understanding-loop-figure": { kind: "figure", label: "Understanding Loop Figure", tags: ["article-figure", "mdx-component"] },
});
